import { render, staticRenderFns } from "./hero.vue?vue&type=template&id=a3c938d4&scoped=true&"
import script from "./hero.vue?vue&type=script&lang=js&"
export * from "./hero.vue?vue&type=script&lang=js&"
import style0 from "./hero.vue?vue&type=style&index=0&id=a3c938d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c938d4",
  null
  
)

export default component.exports